import React, { useCallback, useEffect, useRef, useState } from "react";
import Breadcrump from "../../components/Breadcrump";
import categoryAPI from "../../api/categoryApi";
import CategoryCard from "../categories/Card";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

function ListPage() {
  const [items, setItems] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const observer = useRef();

  useEffect(() => {
    fetchCategories(page);
  }, [page]);

  const fetchCategories = async (currentPage) => {
    setLoading(true);

    try {
      const res = await categoryAPI.listing({ page: currentPage });

      if (res.code === 200) {
        const { items, pagination } = res.data;

        setItems((prev) =>
          currentPage === 1 ? items || [] : [...prev, ...(items || [])],
        );
        setTotalCount(pagination?.totalCount || 0);
      }
    } catch (err) {
      console.error("Error loading categories:", err);
    } finally {
      setLoading(false);
    }
  };

  const lastItemRef = useCallback(
    (node) => {
      if (loading) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && items.length < totalCount) {
          setPage((prev) => prev + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading, items, totalCount],
  );

  return (
    <>
      <Breadcrump title="Category" />

      <section className="s-term-user flat-spacing-25">
        <div className="container">
          {items && items.length > 0 && (
            <>
              <div className="blog-count text-left mb-4">
                Total: <b>{totalCount}</b> categories
              </div>

              <div className="row g-3 mt-2">
                {items.map((item, index) => {
                  if (index === items.length - 1) {
                    return (
                      <div
                        className="col-lg-4 col-6"
                        key={item._id || item.id}
                        ref={lastItemRef}
                      >
                        <CategoryCard item={item} />
                      </div>
                    );
                  }

                  return (
                    <div className="col-lg-4 col-6" key={item._id || item.id}>
                      <CategoryCard item={item} />
                    </div>
                  );
                })}
              </div>
            </>
          )}

          {loading && (
            <div className="text-center mt-4">
              <p>Loading more products...</p>
            </div>
          )}

          {/* End Message */}
          {!loading && items.length >= totalCount && (
            <div className="text-center mt-4">
              <p>✨ You’ve reached the end</p>
            </div>
          )}
        </div>
      </section>






      
    </>
  );
}

export default ListPage;
